export default __webpack_public_path__ + "static/media/book.7ef6a630.png";